import { Component, Input, OnInit } from '@angular/core';

import { Product } from './components/business-areas/products/product';
import { ProductsService } from './components/business-areas/products/products.service';
import { Goal } from './components/sustainability-goals/goals/goal';
import { GoalsService } from './components/sustainability-goals/goals/goals.service';

@Component({
  selector: 'app-canvas',
  templateUrl: './canvas.component.html',
  styleUrls: ['./canvas.component.css']
})
export class CanvasComponent implements OnInit {

  @Input() onShowPeriod;

  showDropdownMenu: Boolean = false;
  dropdownTitle: String = '3 x 3';
  onFlexGrid: String = 'threeBythree';

  onFilter: Boolean = false;
  onEdit: Boolean = false;
  showDragDrop: Boolean = false;

  showGoals: Boolean = true;
  showRating: Boolean = true;
  showBusinessAreas: Boolean = true;
  showTrends: Boolean = true;

  products: Product [];
  mockProducts: Product [];
  mockGoals: Goal [];
  goals: Goal [];

  dropProducts: Boolean = false;
  dropGoals: Boolean = true;

  constructor(
    private _productsService: ProductsService,
    private _goalsService: GoalsService
  ) { }

  getProducts(): void {
    this._productsService.getProducts().then(products => this.products = products);
  }
  getMockProducts(): void {
    this._productsService.getProducts().then(mockProducts => this.mockProducts = mockProducts);
  }

  getMockGoals(): void {
    this._goalsService.getMockGoals().then(mockGoals => this.mockGoals = mockGoals);
  }

  getGoals(): void {
    this._goalsService.getGoals().then(goals => this.goals = goals);
  }

  ngOnInit(): void {
    this.getProducts();
    this.getMockProducts();
    this.getMockGoals();
    this.getGoals();
  }

  periodUpdated(period: String) {
    this.onShowPeriod = period;
    console.log(period);
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/canvas.component.ts